import { isValidEmail } from "@/shared/utils/validation";
/**
 * Maximum addresses accepted in one invitation batch. Mirrors the BFF's
 * `InviteUsersRequest.MaxEmailsPerBatch`; the backend re-checks it, this is the UX gate.
 */
export const MAX_INVITE_EMAILS = 25;
const SEPARATORS = /[\n,;]+/;
/**
 * Parses the free-text address field into the four signals the modal needs. Kept pure and outside
 * the component so the dedup/malformed/cap semantics are testable without mounting anything.
 *
 * Malformed entries are reported rather than discarded: a malformed address hard-blocks the send
 * (the user has a typo to fix), whereas business refusals are only knowable after the call and
 * come back per address from the BFF.
 */
export function parseInviteEmails(raw) {
    const seen = new Set();
    const valid = [];
    const malformed = [];
    let duplicatesRemoved = 0;
    for (const entry of raw.split(SEPARATORS)) {
        const trimmed = entry.trim();
        if (trimmed.length === 0)
            continue;
        const key = trimmed.toLowerCase();
        if (seen.has(key)) {
            duplicatesRemoved += 1;
            continue;
        }
        seen.add(key);
        if (isValidEmail(trimmed)) {
            valid.push(trimmed);
        }
        else {
            malformed.push(trimmed);
        }
    }
    return { valid, malformed, duplicatesRemoved, overCap: valid.length > MAX_INVITE_EMAILS };
}
